<template>
  <div class="experiencefragment aem-GridColumn aem-GridColumn--default--12">
     <div id="experiencefragment-023c0f094e" class="cmp-experiencefragment cmp-experiencefragment--header">
        <div class="xf-content-height">
           <div class="aem-Grid aem-Grid--12 aem-Grid--default--12">
           <div class="responsivegrid aem-GridColumn aem-GridColumn--default--12">
              <div class="aem-Grid aem-Grid--12 aem-Grid--default--12">
                 <div id="headerContainer" class="header aem-GridColumn aem-GridColumn--default--12" role="header">
                 </div>
              </div>
           </div>
        </div>
        </div>
     </div>
  </div>
</template>

<script>
 import { mapGetters } from 'vuex';
 
 export default {
  name: "TheHeader",
   computed: {
   ...mapGetters({
      headerHTML: 'headerHTML'
   })
  },
  methods: {
   assignHeaderHTML(value) {
        document.getElementById('headerContainer').innerHTML = value;
        try {
           setTimeout(function(){
              const charts = document.querySelectorAll('[data-chartid]');
              for(let i = 0; i < charts.length; i++){
                 const chartsWithId = document.querySelectorAll("[data-chartid='" + charts[i].dataset.chartid + "']");
                 for(let j = 0; j < chartsWithId.length; j++){
                    document.querySelectorAll("[data-chartid='" + charts[i].dataset.chartid + "']")[j].href = 'https://aem-stage.microchip.com' + '/en-us/parametric-search.html/' + charts[i].dataset.chartid;
                    document.querySelectorAll("[data-chartid='" + charts[i].dataset.chartid + "']")[j].target = '_blank';
                    document.querySelectorAll("[data-chartid='" + charts[i].dataset.chartid + "']")[j].onclick = null;
                 }
              }
           }, 0);
        } catch(err) {
           //Not to stop the app load when header param chart id is not available
        } 
     }
  },
  mounted() {
   this.$store.dispatch('getHeaderHTML');
  },
  watch:{
   headerHTML: [{
     handler: 'assignHeaderHTML',
     deep: true,
   }],
  }
 }
</script>